import { useState } from "react";

const ACCENT = "#4096ff";
const TEXT_PRIMARY = "#1a2332";
const TEXT_SECONDARY = "#556678";

export function OrgCard({ anggota, size = "md", highlight = false }) {
  const [hovered, setHovered] = useState(false);
  
  // Gunakan satu set dimensi saja (Ukuran Desktop)
  const dimensions = {
    sm: { width: 130, height: 150, nameFontSize: 12, jobFontSize: 10, minTextHeight: 65 },
    md: { width: 150, height: 170, nameFontSize: 13, jobFontSize: 11, minTextHeight: 75 },
    lg: { width: 180, height: 200, nameFontSize: 15, jobFontSize: 12, minTextHeight: 85 },
  };

  const dim = dimensions[size];

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        transition: "transform 0.25s ease",
        transform: hovered ? "translateY(-5px)" : "translateY(0)",
        cursor: "default",
        flexShrink: 0, // Mencegah container mengecil
      }}
    >
      <div
        style={{
          width: dim.width,
          minWidth: dim.width,
          flexShrink: 0, // Kunci ukuran card
          borderRadius: 16,
          overflow: "hidden",
          boxShadow: hovered
            ? highlight
              ? "0 16px 48px rgba(64,150,255,0.30)"
              : "0 12px 32px rgba(0,0,0,0.14)"
            : highlight
            ? "0 6px 24px rgba(64,150,255,0.18)"
            : "0 4px 14px rgba(0,0,0,0.08)",
          transition: "box-shadow 0.25s ease",
          border: highlight ? `2px solid ${ACCENT}` : "2px solid transparent",
          background: "#fff",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            position: "relative", // HARUS RELATIVE
            width: "100%",
            height: dim.height,
            minHeight: dim.height,
            maxHeight: dim.height,
            background: "#e8edf5",
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          <img
            src={anggota.image}
            alt={anggota.nama}
            style={{
              position: "absolute", // HARUS ABSOLUTE (Ini solusi anti-gepeng)
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center top",
              display: "block",
            }}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </div>

        <div
          style={{
            padding: "10px 12px",
            textAlign: "center",
            minHeight: dim.minTextHeight,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            background: highlight
              ? "linear-gradient(135deg, #f0f7ff 0%, #e8f3ff 100%)"
              : "#fff",
          }}
        >
          <span
            style={{
              display: "block",
              fontSize: dim.nameFontSize,
              color: TEXT_PRIMARY,
              fontFamily: "'Quicksand', sans-serif",
              lineHeight: 1.35,
              fontWeight: "bold",
            }}
          >
            {anggota.nama.split(" ")[0]}
          </span>
          <span
            style={{
              display: "block",
              fontSize: dim.jobFontSize,
              color: highlight ? ACCENT : TEXT_SECONDARY,
              fontFamily: "'Quicksand', sans-serif",
              marginTop: 4,
              fontWeight: highlight ? 700 : 600,
              lineHeight: 1.3,
            }}
          >
            {anggota.jabatan}
          </span>
        </div>
      </div>
    </div>
  );
}